export enum WatchlistSummaryType {
    Vertical = 1,
    Rentals = 2,
    SBA = 3,
}

export const WatchlistSummaryTypeOptions = [
    {
        id: WatchlistSummaryType.Vertical,
        name: 'Vertical',
    },
    {
        id: WatchlistSummaryType.Rentals,
        name: 'Rentals',
    },
    {
        id: WatchlistSummaryType.SBA,
        name: 'SBA',
    },
];
